/**
 * TODO: Remove when data comes from Apollo MATTERS_QUERY and related APIs.
 * Reviewers: this file can be skipped in PRs;
 */
import { TravelPlans } from '~/gql/graphql';
import { MatterStatus, WrittenReportNeeded } from '~/shared/types/connect';
import type { Matter, Message } from '~/shared/types/connect';

function hoursAgo(h: number): string {
  return new Date(Date.now() - h * 60 * 60 * 1000).toISOString();
}

export const seedMatters: Matter[] = [
  {
    id: 'matter-1',
    title: 'Thompson v. Mercy Hospital',
    description:
      'Need cardiology expert to opine on standard of care and causation in 68 yo F decedent with post-operative cardiac arrest following elective procedure.',
    keyDates: 'Discovery cutoff: Mar 15, 2025; Trial: Jun 1, 2025',
    nextDeadline: '2025-03-15',
    status: MatterStatus.Active,
    attorneyId: 'attorney-1',
    expertIds: ['expert-1'],
    travelPlans: TravelPlans.Desired,
    writtenReportNeeded: WrittenReportNeeded.Yes,
    side: 'Plaintiff',
    expeditedReviewRequired: false,
    createdAt: hoursAgo(72),
    updatedAt: hoursAgo(2),
  },
  {
    id: 'matter-2',
    title: 'U.S. v. Henderson',
    description:
      'Need forensic accounting review to opine on misappropriation and transaction trail in white-collar fraud matter; expert report and testimony.',
    keyDates: 'Expert report due: Apr 30, 2025; Deposition: May 15, 2025',
    nextDeadline: '2025-04-30',
    status: MatterStatus.Active,
    attorneyId: 'attorney-1',
    expertIds: ['expert-2'],
    travelPlans: TravelPlans.NotApplicable,
    writtenReportNeeded: WrittenReportNeeded.Yes,
    side: 'Defense',
    expeditedReviewRequired: true,
    expeditedReviewTimeframe: '72 hours',
    createdAt: hoursAgo(48),
    updatedAt: hoursAgo(5),
  },
  {
    id: 'matter-3',
    title: 'Martinez v. County General',
    description:
      'Need cardiology second opinion to opine on standard of care and causation in 55 yo M with delayed diagnosis of MI; supplemental report for mediation.',
    keyDates: 'Supplemental report due: Apr 15, 2025; Mediation: May 1, 2025',
    nextDeadline: '2025-04-15',
    status: MatterStatus.Active,
    attorneyId: 'attorney-1',
    expertIds: ['expert-1'],
    travelPlans: TravelPlans.Required,
    writtenReportNeeded: WrittenReportNeeded.Yes,
    side: 'Plaintiff',
    expeditedReviewRequired: false,
    createdAt: hoursAgo(24),
    updatedAt: hoursAgo(1),
  },
  {
    id: 'matter-4',
    title: "Williams v. St. Mary's Medical Center",
    description:
      'Need forensic pathology review to opine on conscious pain and suffering in 72 yo M decedent with head trauma from pedestrian v. car collision.',
    keyDates: 'Discovery closes: Jun 1, 2025; Trial date: Sep 8, 2025',
    nextDeadline: '2025-06-01',
    status: MatterStatus.Pending,
    attorneyId: 'attorney-1',
    expertIds: ['expert-3'],
    travelPlans: TravelPlans.Desired,
    writtenReportNeeded: WrittenReportNeeded.Maybe,
    side: 'Plaintiff',
    expeditedReviewRequired: false,
    createdAt: hoursAgo(96),
    updatedAt: hoursAgo(4),
  },
  {
    id: 'matter-5',
    title: 'U.S. ex rel. Park v. HealthFirst Corp.',
    description:
      'Need forensic accounting and compliance expert to opine on billing practices and regulatory compliance in FCA matter; expert disclosure due.',
    keyDates: 'Expert disclosure: May 20, 2025; Rebuttal: Jun 10, 2025',
    nextDeadline: '2025-05-20',
    status: MatterStatus.Active,
    attorneyId: 'attorney-1',
    expertIds: ['expert-2'],
    travelPlans: TravelPlans.NotApplicable,
    writtenReportNeeded: WrittenReportNeeded.Yes,
    side: 'Defense',
    expeditedReviewRequired: true,
    expeditedReviewTimeframe: '2 weeks',
    createdAt: hoursAgo(36),
    updatedAt: hoursAgo(6),
  },
  {
    id: 'matter-6',
    title: 'Estate of Chen v. Commissioner',
    description:
      'Need tax/estate valuation expert to opine on positions and supporting documentation in dispute with IRS; trial calendar set.',
    keyDates: 'Trial calendar: Jul 2025; Briefing schedule TBD',
    nextDeadline: '2025-07-01',
    status: MatterStatus.Active,
    attorneyId: 'attorney-1',
    expertIds: ['expert-2'],
    travelPlans: TravelPlans.NotApplicable,
    writtenReportNeeded: WrittenReportNeeded.No,
    side: 'Plaintiff',
    expeditedReviewRequired: false,
    createdAt: hoursAgo(60),
    updatedAt: hoursAgo(10),
  },
  {
    id: 'matter-7',
    title: 'Rodriguez v. Davis (potential)',
    description:
      'Need neurology expert to opine on standard of care and causation in potential malpractice matter; consultation phase, no engagement yet.',
    keyDates: 'Consultation phase',
    status: MatterStatus.Pending,
    attorneyId: 'attorney-1',
    invitedExpertIds: ['expert-1'],
    travelPlans: TravelPlans.Desired,
    writtenReportNeeded: WrittenReportNeeded.Maybe,
    side: 'Defense',
    expeditedReviewRequired: false,
    createdAt: hoursAgo(12),
    updatedAt: hoursAgo(1),
  },
  // Demo: matter with multiple active retainers (two experts – cardiology + accounting).
  {
    id: 'matter-8',
    title: 'In re MedTech Securities Litigation',
    description:
      'Multi-expert matter: cardiology opinion on device safety and forensic accounting on revenue recognition; coordinated reports and testimony.',
    keyDates: 'Expert reports due: May 1, 2025; Discovery cutoff: Jun 15, 2025',
    nextDeadline: '2025-05-01',
    status: MatterStatus.Active,
    attorneyId: 'attorney-1',
    expertIds: ['expert-1', 'expert-2'],
    travelPlans: TravelPlans.NotApplicable,
    writtenReportNeeded: WrittenReportNeeded.Yes,
    side: 'Plaintiff',
    expeditedReviewRequired: false,
    createdAt: hoursAgo(168),
    updatedAt: hoursAgo(8),
  },
  // Demo: additional Pending matter.
  {
    id: 'matter-9',
    title: 'Davis v. Regional Transport Authority',
    description:
      'Need accident reconstruction expert to opine on vehicle speed and driver reaction time in bus-pedestrian collision; engagement in progress.',
    keyDates: 'Expert designation: May 30, 2025',
    nextDeadline: '2025-05-30',
    status: MatterStatus.Pending,
    attorneyId: 'attorney-1',
    expertIds: ['expert-2'],
    travelPlans: TravelPlans.Required,
    writtenReportNeeded: WrittenReportNeeded.Yes,
    side: 'Plaintiff',
    expeditedReviewRequired: false,
    createdAt: hoursAgo(120),
    updatedAt: hoursAgo(12),
  },
  // Demo: Closed matters.
  {
    id: 'matter-10',
    title: 'Johnson v. Metro Health System',
    description:
      'Cardiology standard-of-care matter; settled after expert report. Matter closed Jan 2025.',
    keyDates: 'Settled: Jan 15, 2025',
    status: MatterStatus.Closed,
    attorneyId: 'attorney-1',
    expertIds: ['expert-1'],
    travelPlans: TravelPlans.NotApplicable,
    writtenReportNeeded: WrittenReportNeeded.Yes,
    side: 'Plaintiff',
    expeditedReviewRequired: false,
    createdAt: hoursAgo(720),
    updatedAt: hoursAgo(720),
  },
  {
    id: 'matter-11',
    title: 'State v. Morrison',
    description:
      'Forensic accounting review for criminal defense; case concluded with plea agreement.',
    keyDates: 'Closed: Dec 2024',
    status: MatterStatus.Closed,
    attorneyId: 'attorney-1',
    expertIds: ['expert-2'],
    travelPlans: TravelPlans.NotApplicable,
    writtenReportNeeded: WrittenReportNeeded.Yes,
    side: 'Defense',
    expeditedReviewRequired: false,
    createdAt: hoursAgo(960),
    updatedAt: hoursAgo(960),
  },
  // Expert matter with one funded retainer, some hours used – can "Request funds" for more.
  {
    id: 'matter-12',
    title: 'Deposition prep – Baker v. Metro Health',
    description:
      'Cardiology standard-of-care opinion; initial retainer funded, expert has billed 6h and can request additional funds for deposition prep.',
    keyDates: 'Deposition: May 20, 2025',
    nextDeadline: '2025-05-20',
    status: MatterStatus.Active,
    attorneyId: 'attorney-1',
    expertIds: ['expert-1'],
    travelPlans: TravelPlans.Desired,
    writtenReportNeeded: WrittenReportNeeded.Yes,
    side: 'Plaintiff',
    expeditedReviewRequired: false,
    createdAt: hoursAgo(168),
    updatedAt: hoursAgo(8),
  },
  // Demo: matter with 2 retainers, both 0 hrs funded (pending).
  {
    id: 'matter-15',
    title: 'Adams v. City Transit Authority',
    description:
      'Need accident reconstruction and mechanical engineering experts; both retainers approved, pending attorney payment.',
    keyDates: 'Expert designation: Jul 1, 2025',
    nextDeadline: '2025-07-01',
    status: MatterStatus.Active,
    attorneyId: 'attorney-1',
    expertIds: ['expert-1'],
    invitedExpertIds: ['expert-2'],
    travelPlans: TravelPlans.Required,
    writtenReportNeeded: WrittenReportNeeded.Yes,
    side: 'Plaintiff',
    expeditedReviewRequired: false,
    createdAt: hoursAgo(24),
    updatedAt: hoursAgo(2),
  },
  // Demo: matter with 1 active (15h funded) + 1 pending (0h funded) retainer.
  {
    id: 'matter-14',
    title: 'Clark v. Regional Hospital',
    description:
      'Need cardiology and billing experts; one retainer funded, one pending attorney payment.',
    keyDates: 'Expert designation: Jun 20, 2025',
    nextDeadline: '2025-06-20',
    status: MatterStatus.Active,
    attorneyId: 'attorney-1',
    expertIds: ['expert-1'],
    invitedExpertIds: ['expert-2'],
    travelPlans: TravelPlans.Desired,
    writtenReportNeeded: WrittenReportNeeded.Yes,
    side: 'Plaintiff',
    expeditedReviewRequired: false,
    createdAt: hoursAgo(48),
    updatedAt: hoursAgo(4),
  },
  // Demo: matter with mixed retainers – one expert hourly (10 hrs), one expert flat rate ($5,000).
  {
    id: 'matter-16',
    title: 'Peterson v. MedDevice Corp.',
    description:
      'Multi-expert matter: cardiology opinion on device safety (hourly) and forensic accounting for damages (flat fee); coordinated reports.',
    keyDates: 'Expert reports due: Jun 1, 2025; Discovery cutoff: Jul 15, 2025',
    nextDeadline: '2025-06-01',
    status: MatterStatus.Active,
    attorneyId: 'attorney-1',
    expertIds: ['expert-1', 'expert-2'],
    travelPlans: TravelPlans.NotApplicable,
    writtenReportNeeded: WrittenReportNeeded.Yes,
    side: 'Plaintiff',
    expeditedReviewRequired: false,
    createdAt: hoursAgo(96),
    updatedAt: hoursAgo(6),
  },
  // Demo: matter with flat-rate retainer only (no hourly).
  {
    id: 'matter-17',
    title: 'In re Estate of Walsh',
    description:
      'Forensic pathology flat-fee engagement – expert report and deposition prep under a single fixed retainer.',
    keyDates: 'Report due: May 25, 2025; Deposition: Jun 10, 2025',
    nextDeadline: '2025-05-25',
    status: MatterStatus.Active,
    attorneyId: 'attorney-1',
    expertIds: ['expert-3'],
    travelPlans: TravelPlans.Desired,
    writtenReportNeeded: WrittenReportNeeded.Yes,
    side: 'Defense',
    expeditedReviewRequired: false,
    createdAt: hoursAgo(60),
    updatedAt: hoursAgo(4),
  },
  // Demo: Active matter with retainer already paid but fully used – total billed > 0, 0 active.
  {
    id: 'matter-18',
    title: 'Foster v. Riverside Clinic',
    description:
      'Cardiology standard-of-care review; initial retainer was fully used for record review and report. Attorney may add funds for follow-up.',
    keyDates: 'Possible supplemental report: Jun 1, 2025',
    nextDeadline: '2025-06-01',
    status: MatterStatus.Active,
    attorneyId: 'attorney-1',
    expertIds: ['expert-1'],
    travelPlans: TravelPlans.NotApplicable,
    writtenReportNeeded: WrittenReportNeeded.Yes,
    side: 'Plaintiff',
    expeditedReviewRequired: false,
    createdAt: hoursAgo(240),
    updatedAt: hoursAgo(6),
  },
  // Demo: matter with expert hired but no retainer added yet (visible to default expert-1 and attorney-1).
  {
    id: 'matter-13',
    title: 'Green v. Valley Medical Center',
    description:
      'Need cardiology expert to opine on standard of care in post-surgical infection case.',
    keyDates: 'Expert designation: Jun 15, 2025',
    nextDeadline: '2025-06-15',
    status: MatterStatus.Active,
    attorneyId: 'attorney-1',
    expertIds: ['expert-1'],
    travelPlans: TravelPlans.NotApplicable,
    writtenReportNeeded: WrittenReportNeeded.Yes,
    side: 'Plaintiff',
    expeditedReviewRequired: false,
    createdAt: hoursAgo(18),
    updatedAt: hoursAgo(3),
  },
];

export const seedMessages: Message[] = [
  {
    id: 'msg-1',
    matterId: 'matter-1',
    senderId: 'attorney-1',
    content: 'Dr. Carter, I have the medical records ready for your review.',
    createdAt: hoursAgo(48),
    readAt: hoursAgo(47),
  },
  {
    id: 'msg-2',
    matterId: 'matter-1',
    senderId: 'expert-1',
    content:
      'Thank you. I have received them. I will begin my analysis this week.',
    createdAt: hoursAgo(46),
    readAt: hoursAgo(45),
  },
  {
    id: 'msg-3',
    matterId: 'matter-1',
    senderId: 'attorney-1',
    content: 'Great. Let me know if you need any additional documents.',
    createdAt: hoursAgo(44),
  },
  // Unread for attorney: from expert-1, no readAt — shows red unread badge on matter-1 Message button
  {
    id: 'msg-1-unread',
    matterId: 'matter-1',
    senderId: 'expert-1',
    content:
      'I have a quick question about the imaging — can we schedule a short call?',
    createdAt: hoursAgo(3),
  },
  {
    id: 'msg-4',
    matterId: 'matter-2',
    senderId: 'expert-2',
    content: 'I have completed the initial review. Ready to discuss findings.',
    createdAt: hoursAgo(5),
  },
  {
    id: 'msg-5',
    matterId: 'matter-3',
    senderId: 'attorney-1',
    content: 'Dr. Carter, we have the additional records you requested.',
    createdAt: hoursAgo(2),
  },
  {
    id: 'msg-5b',
    matterId: 'matter-4',
    senderId: 'expert-3',
    content:
      'Preliminary review is done. I can have the full report by next week.',
    createdAt: hoursAgo(6),
  },
  {
    id: 'msg-5c',
    matterId: 'matter-5',
    senderId: 'expert-2',
    content:
      'Received the billing data. Starting compliance review this afternoon.',
    createdAt: hoursAgo(4),
  },
  {
    id: 'msg-6',
    matterId: 'matter-7',
    senderId: 'attorney-1',
    content:
      "Thanks for considering this matter. I'd like to discuss scope and availability when you have a moment.",
    createdAt: hoursAgo(10),
  },
  {
    id: 'msg-7',
    matterId: 'matter-7',
    senderId: 'expert-1',
    content: "I've reviewed the summary. Happy to schedule a call this week.",
    createdAt: hoursAgo(8),
  },
  {
    id: 'msg-8',
    matterId: 'matter-8',
    senderId: 'attorney-1',
    content:
      'Dr. Carter and Robert – please coordinate report timelines so we hit the May 1 deadline.',
    createdAt: hoursAgo(96),
  },
  {
    id: 'msg-9',
    matterId: 'matter-8',
    senderId: 'expert-1',
    content:
      'Will align with Robert on sequencing. Cardiology section draft by Apr 20.',
    createdAt: hoursAgo(90),
  },
  // matter-10 (closed): activity from when matter was active.
  {
    id: 'msg-10a',
    matterId: 'matter-10',
    senderId: 'attorney-1',
    content:
      'Dr. Carter, thank you for the expert report. The other side has agreed to settle.',
    createdAt: hoursAgo(720),
  },
  {
    id: 'msg-10b',
    matterId: 'matter-10',
    senderId: 'expert-1',
    content:
      'Glad to hear it. Let me know if you need anything else for the settlement.',
    createdAt: hoursAgo(718),
  },
  {
    id: 'msg-10c',
    matterId: 'matter-10',
    senderId: 'attorney-1',
    content:
      "Settlement finalized. I'll mark this matter closed. Thanks again for your work.",
    createdAt: hoursAgo(715),
  },
  // matter-11 (closed, State v. Morrison): activity from when matter was active.
  {
    id: 'msg-11a',
    matterId: 'matter-11',
    senderId: 'attorney-1',
    content:
      'Robert, the plea agreement is finalized. Thank you for the forensic accounting review and report.',
    createdAt: hoursAgo(960),
  },
  {
    id: 'msg-11b',
    matterId: 'matter-11',
    senderId: 'expert-2',
    content:
      'Glad it helped. Let me know if you need anything else for the file.',
    createdAt: hoursAgo(958),
  },
  {
    id: 'msg-11c',
    matterId: 'matter-11',
    senderId: 'attorney-1',
    content: "Case closed. I'll mark the matter closed on my end.",
    createdAt: hoursAgo(955),
  },
  {
    id: 'msg-12a',
    matterId: 'matter-12',
    senderId: 'attorney-1',
    content:
      'Dr. Carter, deposition is set for May 20. Let me know if you need to request additional hours for prep.',
    createdAt: hoursAgo(8),
  },
  // matter-15 (2 pending retainers)
  {
    id: 'msg-15a',
    matterId: 'matter-15',
    senderId: 'attorney-1',
    content: "Both retainers are approved. I'll fund them by end of week.",
    createdAt: hoursAgo(15),
  },
  // matter-14 (1 active + 1 pending retainer)
  {
    id: 'msg-14a',
    matterId: 'matter-14',
    senderId: 'attorney-1',
    content:
      "Dr. Carter, the 15h retainer is funded. Robert, I'll fund your retainer this week.",
    createdAt: hoursAgo(50),
  },
  // matter-13 (no retainer yet): initial coordination.
  {
    id: 'msg-13a',
    matterId: 'matter-13',
    senderId: 'attorney-1',
    content:
      "Dr. Carter, thanks for agreeing to work on this matter. I'll send the records and we can set up a retainer once you've had a chance to review.",
    createdAt: hoursAgo(3),
  },
  {
    id: 'msg-13b',
    matterId: 'matter-13',
    senderId: 'expert-1',
    content:
      "Sounds good. I'll review and send a retainer request once I've assessed scope.",
    createdAt: hoursAgo(2),
  },
  {
    id: 'msg-16a',
    matterId: 'matter-16',
    senderId: 'attorney-1',
    content:
      'Both retainers are funded – Dr. Carter on hourly, Robert on flat fee. Ready when you are.',
    createdAt: hoursAgo(5),
  },
  // matter-18 (retainer paid but fully used)
  {
    id: 'msg-18a',
    matterId: 'matter-18',
    senderId: 'expert-1',
    content:
      'Report is finalized. Let me know if you’d like to add funds for a supplemental or deposition prep.',
    createdAt: hoursAgo(5),
  },
  {
    id: 'msg-17a',
    matterId: 'matter-17',
    senderId: 'expert-3',
    content:
      "Records received. I'll complete the report under the flat retainer by May 25.",
    createdAt: hoursAgo(3),
  },
];
